module.exports = __webpack_public_path__ + "static/media/9.869af8ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyes/9.png
// module id = 1248
// module chunks = 0